import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Forbidden: React.FC = () => {
  const { t } = useTranslation('common');
  return (
    <div style={{ textAlign: 'center', padding: '4rem 1rem' }}>
      <h1 style={{ fontSize: '3rem', margin: 0 }}>403</h1>
      <p style={{ color: 'var(--text-2)', margin: '1rem 0 2rem' }}>{t('forbidden', { defaultValue: '没有访问该页面的权限' })}</p>
      <Link to="/projects" className="btn btn-primary">{t('backToProjects', { defaultValue: '返回项目列表' })}</Link>
    </div>
  );
};

export default Forbidden;
